/*
 *  THIS COMPONENT IS DEPRECATED
 *  Please use <Input /> from design-system instead
 */
import { Input, InputProps, InputRef } from '@billy/design-system'
import cc from 'classcat'
import get from 'lodash/get'
import React from 'react'

import { ConnectForm, ConnectFormType } from './ConnectForm'
import { ErrorMessage } from './ErrorMessage'

export type FormInputProps = {
  options?: { required?: boolean | string; [key: string]: undefined | boolean | string | {} }
  required?: boolean
  silent?: boolean // Used internally by FormGroup to silence error messages on the single input
  disconnect?: boolean
  errors?: {} // Inherited from context
  register?: Function // Inherited from context
}

export type BaseInputProps = FormInputProps &
  InputProps & {
    autoComplete?: string
    className?: string
    defaultValue?: string | number | string[]
    disabled?: boolean
    errorPath?: string
    id?: string
    label?: string
    name: string
    placeholder?: string
    type?: string
    value?: string | number | readonly string[]
  }

const ActualInput = React.forwardRef<InputRef, BaseInputProps>((props, ref) => <Input ref={ref} {...props} />)

export const BaseInput = React.forwardRef<HTMLInputElement, BaseInputProps>(
  ({
    autoComplete = 'off',
    className,
    disabled,
    disconnect,
    id,
    label,
    name,
    options = {},
    placeholder,
    required,
    type = 'text',
    errorPath,
    silent,
    value,
    ...rest
  }) => (
    <ConnectForm>
      {({ formState, register }: ConnectFormType) => {
        const errors = formState?.errors || {}
        const error = errorPath ? get(errors, errorPath) : errors[name]

        return (
          <>
            <ActualInput
              autoComplete={autoComplete}
              className={cc([className, { invalid: error }])}
              disabled={disabled}
              id={id || name}
              name={name}
              placeholder={placeholder}
              type={type}
              value={value}
              {...(!disconnect && register ? register(name, { required, ...options }) : undefined)}
              {...rest}
            />
            {!silent && <ErrorMessage error={error} />}
          </>
        )
      }}
    </ConnectForm>
  ),
)
